import { type AnimationOptions, NO_ANIMATION_OPTIONS } from "@client/lib/jquery/animate";
import { type GenericMap } from "@client/types";

export const getAnimationOptions = (settings: GenericMap<any> | null | undefined): AnimationOptions => {
  if (!settings) return NO_ANIMATION_OPTIONS;

  return {
    delay: settings.delay,
    direction: settings.direction,
    duration: settings.duration,
    noSpaceIfHidden: !settings.occupySpace,
    type: settings.style,
    trigger: settings.trigger,
    isIn: settings.inOut === "in"
  };
};
